<template>
  <CCard class="cursor p-0 mr-3">
    <CCardHeader class="p-0 position-relative">
      <image-view
        :src="
          blogDetails.cover_photo
            ? blogDetails.cover_photo
            : '/img/avatars/default-user.png'
        "
        alt="user image"
      ></image-view>
      <div class="status-div">
        <div v-if="blogDetails.is_deleted">
          <p class="reject mb-0">Deleted by User</p>
        </div>
        <div v-else>
          <p
            class="mb-0"
            :class="{
              unpublished: currentStatus === 'Unpublished',
              published: currentStatus === 'Published',
              reject: currentStatus === 'Rejected',
              'approval-pending': currentStatus === 'Approval Pending',
            }"
          >
            <b>{{ currentStatus }}</b>
          </p>
        </div>
      </div>
    </CCardHeader>
    <CCardBody class="py-2">
      <h5 class="title text-capitalize">
        <b>{{ blogDetails.title }}</b>
      </h5>
      <div class="d-just-space mb-2">
        <p class="mb-0 text-capitalize">
          {{ blogDetails.created_by.full_name }}
          <br />
          <b>
            <span v-if="currentStatus === 'Published'">Published on</span>
            <span v-else-if="currentStatus === 'Unpublished'">Unpublished on</span>
            <span v-else>Updated on</span>
            {{ getDate(blogDetails.blog_update) }}
          </b>
        </p>
        <div class="d-flex">
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/visibility.png'" class="mr-1 eye-view"></image-view>
            <p class="mb-0">{{ blogDetails.views_count }}</p>
          </div>
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/speech-bubble.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ blogDetails.comment_count ? blogDetails.comment_count : 0 }}</p>
          </div>
          <div class="blog-count d-align">
            <image-view :src="'/img/avatars/like.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ blogDetails.likes.length }}</p>
          </div>
        </div>
      </div>
      <p class="text mb-2">{{ blogDetails.short_description }}</p>
      <div v-if="!blogDetails.is_deleted">
        <v-btn
          class="mb-2"
          v-if="blogDetails.status !== 'DRAFT'"
          @click="getViewDetails()"
          text
          x-large
          color="success"
        >READ MORE</v-btn>
      </div>
    </CCardBody>

    <div v-if="currentStatus !== 'Rejected'">
      <CCardFooter v-if="!blogDetails.is_deleted" class="flex-end xs-flex-dir-col">
        <span v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'">
          <v-btn
            v-if="permissions.includes('CAN_UNPUBLISH_USER_BLOGS')"
            color="success"
            @click="openSwal('unpublish')"
          >Unpublish</v-btn>
        </span>
        <span v-if="!blogDetails.is_published && blogDetails.status === 'APPROVED'">
          <v-btn
            v-if="permissions.includes('CAN_PUBLISH_USER_BLOGS')"
            color="success"
            @click="openSwal('publish')"
          >Publish</v-btn>
        </span>

        <span v-if="!blogDetails.is_published && blogDetails.status === 'PENDING'">
          <v-btn
            class="mr-3"
            v-if="permissions.includes('CAN_PUBLISH_USER_BLOGS')"
            color="success"
            @click="openSwal('Approve & Publish')"
          >Approve & Publish</v-btn>
        </span>
        <span v-if="!blogDetails.is_published && blogDetails.status === 'PENDING'">
          <v-btn
            v-if="permissions.includes('CAN_REJECT_USER_BLOGS')"
            color="error xss-mt-5 xs-width"
            @click="openRejectModal()"
          >Reject</v-btn>
        </span>
      </CCardFooter>
    </div>

    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.rejected_reason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />

      <span
        v-if="reasonData.rejected_reason === '' && alert === true"
        class="text-danger required-fields"
      >{{ requiredAlert }}</span>

      <template #header>
        <h6 class="modal-title text-capitalize">Reason for Reject</h6>
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="submitReason()">Submit</v-btn>
      </template>
    </CModal>
  </CCard>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import config from "@/config.js";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const Image = () => import("@/components/image.vue");
export default {
  props: ["blogDetails"],
  computed: {
    currentStatus() {
      if (
        !this.blogDetails.is_published &&
        this.blogDetails.status === "PENDING"
      ) {
        return "Approval Pending";
      } else if (
        !!this.blogDetails.is_published &&
        this.blogDetails.status === "APPROVED"
      ) {
        return "Published";
      } else if (
        !this.blogDetails.is_published &&
        this.blogDetails.status === "REJECTED"
      ) {
        return "Rejected";
      } else {
        return "Unpublished";
      }
    },
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    "image-view": Image
  },
  data() {
    return {
      reasonData: {
        rejected_reason: ""
      },
      dayJS,
      commentDetails: [],
      commentNumber: "",
      rejectModal: false,
      reasonModal: false,
      alert: false,
      requiredAlert: "This field is required.",
      currentPage: ""
    };
  },
  mounted() {
    // this.getComments();
  },
  methods: {
    openRejectModal() {
      this.rejectModal = true;
    },
    submitReason() {
      this.rejectBlog("reject");
    },

    getViewDetails() {
      this.$router.push(`/user-blog/${this.blogDetails.slug}`);
    },

    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getComments() {
      let url = `${config.BASE_URL}api/v2/blogs/comment/${this.blogDetails._id}`;
      let params = {
        page: this.currentPage,
        records_per_page: 3
      };
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          console.log(response);
          // this.commentNumber = response.body.data.count;
          // if (response.body.data.list) {
          //   this.commentDetails = response.body.data.list;
          // } else {
          //   this.commentDetails = {};
          // }
        } else {
        }
      });
    },
    ApprovePublishBlog(status) {
      let obj;
      if (status === "Approve & Publish" || status === "publish") {
        obj = {
          title: this.blogDetails.title,
          cover_photo: this.blogDetails.cover_photo,
          short_description: this.blogDetails.short_description,
          description: this.blogDetails.description,
          tags: this.blogDetails.tags,
          status: "publish"
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blogDetails._id}/approve`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "Approve & Publish") {
            Swal.fire({
              title: "Blog Approved and Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else if (status === "publish") {
            Swal.fire({
              title: "Blog Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },
    rejectBlog(status) {
      let obj;
      if (this.reasonData.rejected_reason == "") {
        this.alert = true;
        return false;
      } else {
        if (status === "reject") {
          obj = {
            reason: this.reasonData.rejected_reason
          };
        } else {
          obj = {
            is_deleted: true
          };
        }
      }
      console.log(obj);
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blogDetails._id}/reject`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "reject") {
            Swal.fire({
              title: "Blog Rejected",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.rejectModal = false;
                this.$emit("refreshList");
              }
            });
          }
        } else {
          console.log(response);
        }
      });
    },
    updateBlog(status) {
      let obj;
      if (status === "publish" || status === "unpublish") {
        obj = {
          title: this.blogDetails.title,
          cover_photo: this.blogDetails.cover_photo,
          blog_type: "user",
          short_description: this.blogDetails.short_description,
          description: this.blogDetails.description,
          tags: this.blogDetails.tags,
          status: status
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blogDetails._id}`;
      this.$http.post(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "unpublish") {
            Swal.fire({
              title: "Blog Unpublished",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        } else {
          console.log(response);
        }
      });
    },
    openSwal(status) {
      if (status === "Approve & Publish") {
        Swal.fire({
          title: "Are you sure you want to Approve & Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.ApprovePublishBlog(status);
          }
        });
      } else if (status === "publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.ApprovePublishBlog(status);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Unpublish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status);
          }
        });
      }
    }
  }
};
</script>